import { Component, input } from '@angular/core';

@Component({
  selector: 'empathy-viewer-template-card',
  templateUrl: 'template-card.component.html',
  styleUrl: 'template-card.component.scss'
})
export class EmpathyTemplateCardComponent {
  noHeader = input<boolean>(false);
  fullSize = input<boolean>(false);
  fitBox = input<boolean>(false);
}
